import React, { useState, useEffect, useRef, useImperativeHandle } from 'react';
import './index.less'
import Modal from "components/common/modal"
import CheckBoxTreeLocation from './CheckBoxTreeLocation'
import { constructOptions } from 'components/pages/livefeed/Editor/EditorContainer/common/commonFn'
import { alignGaugeCards } from 'actions/livefeed'

const LocationOption = React.forwardRef((props, ref) => {
    const { editorMode, dispatch, nodeMap, setLivefeedOptionsHandle, tree, livefeedSlides, slideType, locationsID } = props;
    const locationOptionRef = useRef(null)
    const treeLocationModal = useRef(null)
    const [summaryLocationsID, setSummaryLocationsID] = React.useState([])
    const [sumPageIndex, setSumPageIndex] = useState(null)

    useImperativeHandle(ref, () => ({
        openLocationsModal: () => {
            openLocationsModal();
        }
    }));
    function openLocationsModal() {
        treeLocationModal.current.open()
    }

    let arrLocations = [];
    constructOptions(tree, arrLocations);

    // the value is always from summary page
    //summaryLocationsID is use for slideShow page

    useEffect(() => {
        let hasSummaryPage = false;
        let locationsID = []
        let sumIndex = null
        // check if chosen LocationsID is in treeMap, handle case if the id of node in tree map has changed

        for (let i = 0, n = livefeedSlides.length; i < n; i++) {
            if (livefeedSlides[i].slideType === "summary") {
                hasSummaryPage = true;
                sumIndex = i
                locationsID = livefeedSlides[i].floorplanOptions.locationsID
            }
        }
        let refinedLocationsID = locationsID.filter(id => nodeMap[id])
        if (hasSummaryPage) {
            setSummaryLocationsID(refinedLocationsID)
            setSumPageIndex(sumIndex)
        } else {
            setSummaryLocationsID([])
            setSumPageIndex(null)
        }

    }, [livefeedSlides, nodeMap])

    let isAllAreas = undefined; let isMR = false; let isOA = false; // isMeetingRooms// isOpenAreas
    if (sumPageIndex !== null) {
        for (let i = 0, n = summaryLocationsID.length; i < n; i++) {
            if (summaryLocationsID[i] !== undefined) {
                let node = nodeMap[summaryLocationsID[i]]
                switch (node.type) {
                    case "meeting_room":
                        isMR = true
                        break;
                    case "open_area":
                        isOA = true
                        break;
                }
            }
            if (isOA && isMR) {
                isAllAreas = true
            } else {
                isAllAreas = false
            }
        }
    }

    useEffect(() => {
        console.log("editorMode", editorMode)
        if (sumPageIndex !== null && (editorMode !== "editTemplate" && editorMode !== "editLivefeed")) {
            if (isAllAreas) {
                dispatch(alignGaugeCards("all", sumPageIndex))
            } else {
                if (isMR) {
                    dispatch(alignGaugeCards("mr", sumPageIndex))
                } else if (isOA) {
                    dispatch(alignGaugeCards("oa", sumPageIndex))
                }
            }
        }
    }, [editorMode, dispatch, isAllAreas, isMR, isOA, sumPageIndex])



    return (
        <div ref={locationOptionRef} className="location-grid-item">
            <div className="editor-container">
                <div className="header grid-item">{slideType !== "summary" ? 'SENZOLIVE LOCATION' : 'SENZOLIVE LOCATIONS'}</div>
                <span className="editor-text grid-item grid-item__title"
                    data-for="floorplanOptionsTooltip"
                    data-tip="Data&nbsp;of&nbsp;the&nbsp;chosen&nbsp;location will&nbsp;be&nbsp;displayed&nbsp;in&nbsp;this&nbsp;slide" style={{ whiteSpace: "normal" }}>
                    {slideType !== "summary" ? 'Choose locations' : 'Choose locations will be shown on livefeed slides'}
                </span>
                <div className="editor-text grid-item livefeed-editor-location">
                    <Modal
                        ref={treeLocationModal}
                        clickButton={() => treeLocationModal.current.close()}
                        header="Choose locations"
                        buttonText="Done"
                        buttonClass="btn-success hidden"
                        disableCloseButton={true}
                        entry={
                            <button className="btn btn-success" onClick={() => openLocationsModal()}>
                                Click to see options
                            </button>
                        }
                    >
                        <div className="location-dropdown">
                            <CheckBoxTreeLocation
                                arrLocations={arrLocations}
                                onlyLeafCheckboxes={false}
                                slideType={slideType}
                                summaryLocationsID={summaryLocationsID}
                                locationsID={locationsID}
                                setLivefeedOptionsHandle={(value) =>
                                    setLivefeedOptionsHandle(
                                        slideType !== "summary" ? "slideshowLocations" : "summaryLocations",
                                        value)
                                }
                            />
                        </div>
                    </Modal>
                </div>
            </div>
        </div >
    );
})


export default LocationOption;


// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/FloorplanOptionContainer/LocationOption/index.jsx